"use client";

import { useEffect } from "react";

/**
 * 004.17: Add YouTube preconnect only on media pages (embeds and thumbnails).
 * Injects link tags on mount and removes on unmount so other pages don't preconnect.
 */
export default function MediaPreconnect() {
  useEffect(() => {
    const links: HTMLLinkElement[] = [];
    const hrefs = ["https://www.youtube.com", "https://i.ytimg.com"];
    for (const href of hrefs) {
      const link = document.createElement("link");
      link.rel = "preconnect";
      link.href = href;
      document.head.appendChild(link);
      links.push(link);
    }
    return () => {
      for (const link of links) {
        document.head.removeChild(link);
      }
    };
  }, []);
  return null;
}
